import React from 'react';

import { LinkButton } from '../common/input/Button.jsx';
import { Fullscreen as LoadingFull } from '../common/container/Loading.jsx';

function InvoiceConfirmation(props) {
    const [error, setError] = React.useState(undefined);
    const [loading, setLoading] = React.useState(true);
    const [timeoutHandle, setTimeoutHandle] = React.useState(undefined);
    const handleViewInvoice = () => {
        if (timeoutHandle) {
            clearTimeout(timeoutHandle);
            setTimeoutHandle(undefined);
        }
        const index = window.location.href.indexOf('/confirmation');
        if (index >= 0) {
            window.location.replace(window.location.href.substring(0, index));
        }
    }
    React.useEffect(() => {
        const PaymentIntentClientSecret = Artcloud.util.getparameterbyname('payment_intent_client_secret');
        const PaymentIntentId = Artcloud.util.getparameterbyname('payment_intent');
        Artcloud.api.post(
            Artcloud.url.vendor.marketplace.invoices.captures.post(props.query),
            { PaymentIntentClientSecret, PaymentIntentId },
            () => {
                setLoading(false);

                const handle = setTimeout(handleViewInvoice, 5000)
                setTimeoutHandle(handle);
            }
        ).fail(jqXHR => {
            setLoading(false);
            setError(jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.Message)
        });
    }, [])
    return (
        <div className="cover__container cover--invoice">
            <div className="container">
                {
                    loading ?
                        <LoadingFull style={{ backgroundColor: '#222' }} />
                        :
                        <>
                            <div className="cover__content">
                                <div className="cover__name cover__name--gallery">
                                    <h3 style={{ textAlign: 'center', width: '100%' }}>
                                        {
                                            error != undefined ?
                                                <>
                                                    Payment Failed
                                                    <span className="cover__location" style={{ color: 'red' }}>{error}</span>
                                                </>
                                                :
                                                <>
                                                    Payment Successful
                                                    <span className="cover__location">You will be redirected back to your invoice shortly.</span>
                                                    <span className="cover__location">Please do not use your browser's Back button.</span>
                                                </>
                                        }
                                    </h3>
                                </div>
                            </div>
                            <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                                <span className="text--center spacer--bottom">
                                    <LinkButton config={{ color: 'dark', size: 'medium', style: 'fill' }} onClick={handleViewInvoice}>View Invoice</LinkButton>
                                </span>
                            </div>
                        </>
                }
            </div>
        </div>
    )
}

export default InvoiceConfirmation;